<script setup>
import { computed } from "vue";

const props = defineProps({
    badges: {
        type: Array,
        default: null,
    },
    eyebrow: {
        type: String,
        default: "Vertrouwd en transparant",
    },
});

const defaultBadges = [
    {
        label: "GDPR-conform",
        description: "Volledig in lijn met de AVG-wetgeving.",
        icon: "shield",
    },
    {
        label: "EU-gehost",
        description: "Data blijft binnen de Europese Unie.",
        icon: "server",
    },
    {
        label: "EU-gebouwd",
        description: "Ontwikkeld in België door een Belgisch team.",
        icon: "flag",
    },
];

const resolvedBadges = computed(() => props.badges ?? defaultBadges);
</script>

<template>
  <section class="bg-white py-16 sm:py-20">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <p class="text-center text-sm font-semibold uppercase tracking-wide text-indigo-600">
        {{ eyebrow }}
      </p>
      <div class="mx-auto mt-8 grid max-w-4xl grid-cols-1 gap-6 sm:grid-cols-3">
        <div
          v-for="badge in resolvedBadges"
          :key="badge.label"
          class="flex flex-col items-center rounded-2xl border border-gray-200 bg-white px-6 py-6 text-center"
        >
          <span class="flex h-10 w-10 items-center justify-center rounded-full bg-indigo-50 text-indigo-600">
            <svg
              v-if="badge.icon === 'server'"
              class="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.8"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M5.25 14.25h13.5m-13.5 0a3 3 0 0 1-3-3m3 3a3 3 0 1 0 0 6h13.5a3 3 0 1 0 0-6m-16.5-3a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3m-19.5 0a4.5 4.5 0 0 1 .9-2.7L5.737 5.1a3.375 3.375 0 0 1 2.7-1.35h7.126c1.062 0 2.062.5 2.7 1.35l2.587 3.45a4.5 4.5 0 0 1 .9 2.7m0 0a3 3 0 0 1-3 3m0 3h.008v.008h-.008v-.008Zm0-6h.008v.008h-.008v-.008Zm-3 6h.008v.008h-.008v-.008Zm0-6h.008v.008h-.008v-.008Z"
              />
            </svg>
            <svg
              v-else-if="badge.icon === 'flag'"
              class="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.8"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5"
              />
            </svg>
            <svg
              v-else
              class="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.8"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"
              />
            </svg>
          </span>
          <p class="mt-4 text-sm font-semibold text-gray-900">
            {{ badge.label }}
          </p>
          <p
            v-if="badge.description"
            class="mt-1 text-sm text-gray-600"
          >
            {{ badge.description }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
